/* eslint-disable no-new */
/**
 * @class Map
 * 지도 스크립트 초기화와 그림
 *
 * 네이버 지도는 아래 문서 참고하여 구현
 * https://navermaps.github.io/maps.js/docs/index.html
 */
export default class Map {
  constructor() {
    const {
      bIsDeliveryDeal,
      htDealInfo: { localShopList },
    } = TMON.oApp.htStorage.htStaticData;
    if (bIsDeliveryDeal || (!localShopList && localShopList.length < 1)) return;

    this.bIsUsing = true;

    this.bInited = false; // 지도 스크립트의 초기화 여부
    this.bProcessingGetScript = false; // 지도 스크립트를 불러오는 중인지 여부 (여러 군데에서 'setMap' 변경이 호출될 경우 스크립트 중복 호출을 방지)

    this.mapList = {}; // 초기화된 지도 객체 목록
  }

  update(sStorageKey) {
    if (!this.bIsUsing) return;

    const { scene, renderMap } = TMON.oApp.htStorage;

    switch (sStorageKey) {
      case 'scene':
        if (scene === 'partnerInfo' && renderMap) {
          // 지도가 초기화되지 않았고 스크립트를 불러오는 중이 아니면
          if (!this.bInited && !this.bProcessingGetScript) {
            // 지도 초기화
            this.initMap();
            break;
          }

          // 스크립트 불러져있으면
          // 전달받은 옵션으로 지도 초기화
          this.setMap();
        }
        break;
      case 'renderMap':
        if (
          (scene === 'partnerInfo' ||
            TMON.oApp.sPlatform === 'PW' ||
            TMON.oApp.sPlatform === 'MW' ||
            TMON.oApp.sPlatform === 'MA') &&
          renderMap
        ) {
          // 지도가 초기화되지 않았고 스크립트를 불러오는 중이 아니면
          if (!this.bInited && !this.bProcessingGetScript) {
            // 지도 초기화
            this.initMap();
            break;
          }

          // 스크립트 불러져있으면
          // 전달받은 옵션으로 지도 초기화
          if (scene === 'partnerInfo' || TMON.oApp.sPlatform === 'PW') {
            this.setMap();
          }
        }
        break;
      case 'setCurrentLocation':
        // 전달받은 옵션 사용자의 현재 위치 설정
        this.setCurrentLocation();
        break;
      default:
        break;
    }
  }

  initMap() {
    // 로딩 이미지 보임
    this.showMapLoading();
    // 스크립트 부른다
    this.getMapScript();

    // 스크립트 호출 중임을 저장
    this.bProcessingGetScript = true;
  }

  /**
   * 지도 스크립트 초기화 상태를 확인하여 스크립트를 삽입하는 함수
   * 성공과 실패 여부에 따라 cb 함수 호출
   */
  getMapScript() {
    this.bProcessingGetScript = true;
    $.getScript(
      'https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=zcolk7f7dy'
    )
      .done(this.cbSuccessGetMapScript)
      .fail(this.hideMap);
  }

  cbSuccessGetMapScript = () => {
    this.bInited = true;
    this.bProcessingGetScript = false;

    this.hideMapLoading();
    this.setMap();
  };

  showMapLoading() {
    const { renderMap } = TMON.oApp.htStorage;

    $(`#${renderMap.sWrapperId}`).addClass('loading');
  }

  hideMapLoading() {
    const { renderMap } = TMON.oApp.htStorage;

    $(`#${renderMap.sWrapperId}`).removeClass('loading');
  }

  setMap() {
    const { renderMap } = TMON.oApp.htStorage;

    if (!this.mapList[renderMap.sWrapperId]) {
      this.mapList[renderMap.sWrapperId] = {};
      // wrapper에 지도 초기화
      this.mapList[renderMap.sWrapperId].oMap = new window.naver.maps.Map(
        renderMap.sWrapperId,
        {
          center: new window.naver.maps.LatLng(renderMap.lat, renderMap.lng),
          zoom: 13,
        }
      );

      // 핀 설정
      this.mapList[renderMap.sWrapperId].oPin = new window.naver.maps.Marker({
        position: new window.naver.maps.LatLng(renderMap.lat, renderMap.lng),
        map: this.mapList[renderMap.sWrapperId].oMap,
        icon: {
          url: `${TMON.htLocal.htURL.resourcePath}/img/deals/map_pin@2x.png`, // 50, 68 크기의 원본 이미지
          scaledSize: new window.naver.maps.Size(25, 34),
        },
      });

      // 컨트롤 가능 여부에 따라서 컨트롤 활성화 상태 설정
      if (renderMap.bIsAvailableInteractMap) {
        // 지도 인터랙션 켜기
        this.mapList[renderMap.sWrapperId].oMap.setOptions({
          draggable: true,
          pinchZoom: true,
          scrollWheel: true,
          keyboardShortcuts: true,
          disableDoubleTapZoom: false,
          disableDoubleClickZoom: false,
          disableTwoFingerTapZoom: false,
        });
      } else {
        // 지도 인터랙션 끄기
        this.mapList[renderMap.sWrapperId].oMap.setOptions({
          draggable: false,
          pinchZoom: false,
          scrollWheel: false,
          keyboardShortcuts: false,
          disableDoubleTapZoom: true,
          disableDoubleClickZoom: true,
          disableTwoFingerTapZoom: true,
        });
      }
    } else {
      const oLatLng = new window.naver.maps.LatLng(
        renderMap.lat,
        renderMap.lng
      );
      this.mapList[renderMap.sWrapperId].oMap.setZoom(13);
      this.mapList[renderMap.sWrapperId].oMap.setCenter(oLatLng);
      this.mapList[renderMap.sWrapperId].oPin.setPosition(oLatLng);
    }
  }

  setCurrentLocation() {
    const { setCurrentLocation } = TMON.oApp.htStorage;

    const sMapWrapper = setCurrentLocation.sWrapperId;
    const { oMap } = this.mapList[sMapWrapper];
    const oLatLng = new window.naver.maps.LatLng(
      setCurrentLocation.lat,
      setCurrentLocation.lng
    );

    oMap.setZoom(13);
    oMap.setCenter(oLatLng);

    this.mapList[sMapWrapper].oCurrentPin = new window.naver.maps.Marker({
      position: oLatLng,
      map: oMap,
      icon: {
        url: `${TMON.htLocal.htURL.resourcePath}/img/deals/map_pin@2x.png`, // 50, 68 크기의 원본 이미지
        scaledSize: new window.naver.maps.Size(25, 34),
      },
    });
  }
}
